import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoUrl from './../../assets/img/logo_negative.svg';

const Footer = (props) => {
    if (!props.general) {
      return null;
    }

    return <footer className="site-footer">
        <div className="container">
            <div className="row">
                <div className="col-md">
                    <Link to="/" className="logo">
                        <img src={LogoUrl} alt={props.general.title}/>
                    </Link>
                </div>
                <div className="col-md">
                    <h3>Genvägar</h3>
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum dolor</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md">
                    <h3>Information</h3>
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum dolor</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md">
                    <h3>Följ oss</h3>
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum dolor</a>
                        </li>
                        <li className="nav-item">
                            <a href="" className="nav-link">Lorem ipsum</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
};

export default connect(
  state => {
    return {
      general: state.generalState.general
    }
  },
)(Footer);
